import { render, staticRenderFns } from "./case-dashboard.vue?vue&type=template&id=dd9aab64&scoped=true"
import script from "./case-dashboard.vue?vue&type=script&lang=js"
export * from "./case-dashboard.vue?vue&type=script&lang=js"
import style0 from "./case-dashboard.vue?vue&type=style&index=0&id=dd9aab64&prod&lang=scss"
import style1 from "./case-dashboard.vue?vue&type=style&index=1&id=dd9aab64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9aab64",
  null
  
)

export default component.exports